import { render, staticRenderFns } from "./Gerocare.vue?vue&type=template&id=4ed57c82&"
import script from "./Gerocare.vue?vue&type=script&lang=js&"
export * from "./Gerocare.vue?vue&type=script&lang=js&"
import style0 from "./Gerocare.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../Volumes/Work/Work/gerocare/CrmWeb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports